import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LeftColumn = styled.div``;

export const $Heading = styled.div`
  font-weight: 800;
  ${fontStyle('base')};
  ${mediaQuery.sm`
    font-size: 20px;
  `}

  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing('xl')};
  display: flex;
  align-items: center;
`;

export const $HeadingIcon = styled.span`
  margin-right: ${spacing('lg')};
  display: flex;
  align-items: baseline;
  & svg {
    width: ${spacing('xl')};
    height: ${spacing('xl')};
  }
`;

export const $ConfirmationWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  ${mediaQuery.sm`
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: ${spacing('xxl')};
  `};
`;

export const $ConfirmationItemWrapper = styled.div`
  flex: 1;
  margin-top: ${spacing(12)};
  ${mediaQuery.xs`
    input:first-child {
      margin-bottom: ${spacing('lg')};
    }
  `}
`;

export const $ConfirmationResultWrapper = styled.div`
  flex: 1;
  margin-bottom: ${spacing('xxl')};
`;

export const $AgreementRow = styled(Row)`
  margin-top: ${spacing('xxl')};
  margin-bottom: ${spacing(12)};
`;
